import { axios, createFormData, handleError } from '../axios';

export const addComment = (data) => {
  return new Promise((resolve, reject) => {
    const url = data.replies ? 'admin/post/comment' : 'post/comment/';
    axios
      .post(url, createFormData(data))
      .then((response) => {
        resolve(response.data);
      })
      .catch((e) => {
        handleError(e);
        reject(e);
      });
  });
};
